import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'

import { SecaoAcoesEmpreendimento } from '@/features/empreendimentos/chile/pages/detalhes-empreendimento/components/secao-acoes-empreendimento'
import { DialogSelecionarArquivo } from '@/features/empreendimentos/shared/components/dialog-selecionar-arquivo'
import { SecaoLocalizacao } from '@/features/empreendimentos/shared/components/secao-localizacao'
import { SecaoMidias } from '@/features/empreendimentos/shared/components/secao-midia'
import { SecaoSobre } from '@/features/empreendimentos/shared/components/secao-sobre'
import { DownloadManager } from '@/features/empreendimentos/shared/domain/download-manager.entity'
import { useDetalhesEmpreendimentoSuspense } from '@/features/empreendimentos/shared/hooks/use-detalhes-empreendimento-suspense'
import { showToast } from '@/infra'
import { PageChile as Page } from '@/layouts/page-chile'

export const DetalhesEmpreendimentoPage = () => {
  const { t } = useTranslation('empreendimentos')
  const { idExterno } = useParams<{ idExterno: string }>()
  const navigate = useNavigate()
  const { data } = useDetalhesEmpreendimentoSuspense(Number(idExterno))
  const breadcrumb = [
    { label: t('pages.detalhes.breadcrumb.empreendimentos'), to: '/es-CL/empreendimentos' },
    { label: data.nome },
  ]

  const handleFotosClick = () => {
    if (!data.possuiFotos) {
      showToast({ variant: 'error', message: t('pages.detalhes.secoes.midia.sem_fotos') })
      return
    }

    navigate(`/es-CL/empreendimentos/${idExterno}/fotos`)
  }

  const handlePlantasClick = () => {
    if (!data.possuiPlantas) {
      showToast({ variant: 'error', message: t('pages.detalhes.secoes.midia.sem_plantas') })
      return
    }

    navigate(`/es-CL/empreendimentos/${idExterno}/plantas`)
  }

  const handleBookDownload = async () => {
    if (!data.possuiBook) {
      showToast({ variant: 'error', message: t('pages.detalhes.secoes.midia.sem_arquivos') })
      return
    }

    const { data: dialogData, value } = await DialogSelecionarArquivo.show({
      idExterno: data.idExterno,
      nomeEmpreendimento: data.nome,
    })

    if (value === 'confirm' && dialogData) {
      DownloadManager.downloadWithLink(dialogData.arquivoSelecionadoId, `${data.nome} - ${dialogData.nomeArquivo}`)
    }
  }

  return (
    <Page className="grid gap-4" breadcrumb={breadcrumb}>
      <Page.Main>
        <Page.Header>
          <Page.Title className="uppercase">{t('pages.detalhes.titulo', { nome: data.nome })}</Page.Title>
        </Page.Header>
        <Page.Section className="space-y-12">
          <SecaoMidias
            onBookClick={handleBookDownload}
            onFotosClick={handleFotosClick}
            onPlantasClick={handlePlantasClick}
          />
          <SecaoSobre resumo={data.resumo} metragem={data.metragem} quartos={data.quartos} entregas={data.entregas} />
          <SecaoLocalizacao
            endereco={data.localizacao?.endereco}
            latitude={data.localizacao?.latitude}
            longitude={data.localizacao?.longitude}
          />
          {!data.empreendimentoFuturo && (
            <SecaoAcoesEmpreendimento breadcrumb={breadcrumb} idExterno={data.idExterno} tipo={data.tipo} />
          )}
        </Page.Section>
      </Page.Main>
    </Page>
  )
}
